import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconDash = createIcon({
  displayName: 'IconDash',
  path: [<path key="0" d="M21 11H3V13H21V11Z" fill="currentColor" />],
  viewBox: '0 0 24 24',
})
